import React, { Component } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Button, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { BlankCard } from '../../Base/Common/CommonUIComponents';
import CustomSelect from '../../Base/Common/CustomSelect';
import { deleteAPI, postAPI } from '../../Base/API';
import { handleNotification } from '../../Base/Notification';
import { getCurrencyCode } from '../../Base/Common/ReferenceDataFunctions';

// Codes the shared currency list keeps for data already stored with them, but that the server does not accept for a new
// exchange rate: retired currencies, and the Lesotho loti, which the server's region data does not know
const NotAcceptedCurrencies = ['BYR', 'CUC', 'EEK', 'GQE', 'HRK', 'LSL', 'LTL', 'LVL', 'MRO', 'MZM', 'SLL', 'VEB', 'ZMK', 'ZWR'];

// Without modalData the modal creates a new pair; with it, it edits or removes the hotel's fixed rate of that pair
export class EditCurrencyModal extends Component {

    constructor(props) {
        super(props);
        this.editCurrencyForm = React.createRef();

        const { modalData } = this.props;

        this.state = {
            block: false,
            baseCurrency: modalData ? modalData.baseCurrency : null,
            targetCurrency: modalData ? modalData.targetCurrency : null,
            rate: modalData ? modalData.rate : ''
        };
    }

    handleRate = (evt) => {
        if (evt && evt.target) {
            const { name, value } = evt.target;
            this.setState({ [name]: value });
        }
    }

    handleCurrency = (name, combo) => {
        this.setState({ [name]: combo ? combo.value : null });
    }

    getCurrencyOption = (currencies, currency) => {
        if (!currency) {
            return null;
        }
        return currencies.find(crr => crr.value === currency) || { value: currency, label: currency };
    }

    handleSave = () => {
        if (this.editCurrencyForm.current.reportValidity()) {
            const { reloadCurrencies, toggle } = this.props;
            const { baseCurrency, targetCurrency, rate } = this.state;

            this.setState({ block: true });

            const request = {
                baseCurrency: baseCurrency,
                targetCurrency: targetCurrency,
                rate: rate
            };

            postAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ block: false, error: errorMessage });
                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="CurrencyConversion.SuccessSave" />, <FormattedMessage id="General.Success" />);
                    this.setState({ block: false, error: errorMessage });

                    if (!data.errors || data.errors.length === 0) {
                        reloadCurrencies();
                        toggle();
                    }
                }
                else {
                    this.setState(({ block: false, error: errorMessage }));
                }
            }, '/api/Price/Price/Currency/v1/exchange', request);
        }
    }

    handleRemove = () => {
        const { modalData, reloadCurrencies, toggle } = this.props;

        this.setState({ block: true });
        deleteAPI(result => {
            const { data, error } = result;
            const errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ block: false, error: errorMessage });
                return;
            }
            else {
                handleNotification(data, <FormattedMessage id="CurrencyConversion.SuccessRemove" />, <FormattedMessage id="General.Success" />);
                this.setState({ block: false, error: errorMessage });
                reloadCurrencies();
                toggle();
            }
        }, `/api/Price/Price/Currency/v1/exchange/${modalData.baseCurrency}/${modalData.targetCurrency}`);
    }

    render() {
        const { modal, toggle, modalData } = this.props;
        const { block, error, baseCurrency, targetCurrency, rate } = this.state;

        const isNew = !modalData;
        const currencies = isNew ? getCurrencyCode().filter(crr => !NotAcceptedCurrencies.includes(crr.value)) : getCurrencyCode();

        return (
            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    <FormattedMessage id={isNew ? "CurrencyConversion.NewCurrencyRate" : "CurrencyConversion.EditCurrencyRate"} />
                </ModalHeader>
                <ModalBody>
                    <BlankCard block={block} error={error}>
                        <form ref={this.editCurrencyForm}>
                            <Row className="mb-2">
                                <Col className="text-right">
                                    {
                                        !isNew ?
                                            <Button className="btn btn-host btn-sm mr-2" onClick={this.handleRemove}>
                                                <i className="fas fa-trash-alt" />
                                            </Button>
                                            :
                                            <span />
                                    }
                                    <Button className="btn btn-host btn-sm" onClick={this.handleSave}>
                                        <i className="fas fa-save" />
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-2">
                                    <FormattedMessage id="CurrencyConversion.BaseCurrency" />
                                </Col>
                                <Col className="col-3">
                                    <CustomSelect
                                        options={currencies.filter(crr => crr.value !== targetCurrency)}
                                        value={this.getCurrencyOption(currencies, baseCurrency)}
                                        onChange={this.handleCurrency.bind(this, 'baseCurrency')}
                                        isDisabled={!isNew}
                                        required
                                    />
                                </Col>
                                <Col>
                                    <FormattedMessage id="CurrencyConversion.TargetCurrency" />
                                </Col>
                                <Col className="col-3">
                                    <CustomSelect
                                        options={currencies.filter(crr => crr.value !== baseCurrency)}
                                        value={this.getCurrencyOption(currencies, targetCurrency)}
                                        onChange={this.handleCurrency.bind(this, 'targetCurrency')}
                                        isDisabled={!isNew}
                                        required
                                    />
                                </Col>
                                <Col>
                                    <FormattedMessage id="CurrencyConversion.Rate" />
                                </Col>
                                <Col>
                                    <Input type="number" id="rate" name="rate" value={rate} onChange={this.handleRate} required min="0.000001" step="0.000001" />
                                </Col>
                            </Row>
                        </form>
                    </BlankCard>
                </ModalBody>
            </Modal>
        );
    }
}